import * as React from 'react';

import { Purchase } from 'root/apps/PurchaseOrder/NuorderOrdering/types';

export const useClearViewFunctions = (purchase: Purchase | null) => {
  const [viewFunctionsCleared, setViewFunctionsCleared] = React.useState<boolean>(false);

  const reviewButtonSelector = '#review_nuorder_po_btn';
  const orderedButtonSelector = '#po_mode_ordered';
  const checkingButtonSelector = '#po_mode_checkin';

  React.useEffect(() => {
    if (viewFunctionsCleared) return;
    if (!purchase) return;
    if (!purchase.b2bOrderUID) return;
    document.querySelectorAll(reviewButtonSelector).forEach((el) => {
      el.classList?.add('hidden');
    });
    document.querySelectorAll(orderedButtonSelector).forEach((el) => {
      el.classList?.add('hidden');
    });
    document.querySelectorAll(checkingButtonSelector).forEach((el) => {
      el.classList?.remove('hidden');
    });
    setViewFunctionsCleared(true);
  }, [purchase, viewFunctionsCleared]);

  return { viewFunctionsCleared, setViewFunctionsCleared };
};
